// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"94745bcb","239":"83642894","453":"d4c6fbe5","455":"849b67b2"}[chunkId] + ".chunk.js";
};